import { Component, Input, OnInit } from "@angular/core";
import { Question } from "../Models/question.interface";
import { Profile } from "../Models/profile.interface";
import { ScrollService } from "../Services/ScrollManager/scroll.service";
import { Message } from "../Models/conversation.interface";
import { UserManager } from "../Services/UserManager/user-manager";
import {
  trigger,
  state,
  style,
  transition,
  animate,
} from "@angular/animations";
@Component({
  selector: "student-question-button",
  templateUrl: "./student-question-button.component.html",
  styleUrls: [
    "./student-question-button.component.css",
    "../templates/question-template/question-template.component.scss",
  ],
  animations: [
    trigger("userQuestion", [
      state(
        "show",
        style({
          opacity: 1,
          transform: "translateY(0%)",
        })
      ),
      state(
        "void",
        style({
          transform: "translateY(50%)",
          opacity: 0,
        })
      ),
      transition(
        "void => show",
        animate(
          "300ms  ease-out",
          style({ opacity: 1, transform: "translateY(0%)" })
        )
      ),
      transition(
        "show => void",
        animate(
          "300ms  ease-out",
          style({ opacity: 0, transform: "translateY(50%)" })
        )
      ),
    ]),
  ],
})
export class StudentQuestionButtonComponent implements OnInit {
  @Input() question: Question;
  @Input() profile: Profile;
  @Input() config;
  userQuestion = "void";
  questionMessage;
  questionError;
  questionUserEmail;
  constructor(private scroll: ScrollService, private um: UserManager) {}

  ngOnInit(): void {}

  openStudentQuestion() {
    this.userQuestion = "show";
    this.scroll.scrollToElement("#questionTitleInput");
  }

  closeStudentQuestion() {
    this.userQuestion = "void";
    this.questionMessage = "";
    // this.questionUserEmail = ""
    this.questionError = "";
  }

  submitStudentQuestion(event) {
    event.stopPropagation();
    if (!this.questionMessage) {
      this.questionError = this.config.questionTemplateErrorNeedMessage;
      return;
    }
    if (!this.questionUserEmail) {
      this.questionError = this.config.questionTemplateErrorNeedEmail;
      return;
    }
    this.questionError = "";
    var message = {} as Message;
    message.message = this.questionMessage;
    message.profileEmail = this.questionUserEmail;

    this.um
      .startConversation(
        message,
        this.question.lessonID,
        this.question.questionID
      )
      .then((result) => {
        if (result) {
          this.closeStudentQuestion();
        } else {
          this.questionError = this.config.questionTemplateErrorUnknown;
        }
      })
      .catch((e) => (this.questionError = e));
  }
}
